/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createProblemDetailsFromDiscriminatorValue, type ProblemDetails } from '../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Guid, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /registrations/export/rev
 */
export interface RevRequestBuilder extends BaseRequestBuilder<RevRequestBuilder> {
    /**
     * ExportRegistrationsAsRevXml
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<ArrayBuffer>}
     * @throws {ProblemDetails} error when the service returns a 400 status code
     * @throws {ProblemDetails} error when the service returns a 404 status code
     * @throws {ProblemDetails} error when the service returns a 409 status code
     */
     get(requestConfiguration?: RequestConfiguration<RevRequestBuilderGetQueryParameters> | undefined) : Promise<ArrayBuffer | undefined>;
    /**
     * ExportRegistrationsAsRevXml
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<RevRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
}
/**
 * ExportRegistrationsAsRevXml
 */
export interface RevRequestBuilderGetQueryParameters {
    registrationId?: Guid;
}
/**
 * Uri template for the request builder.
 */
export const RevRequestBuilderUriTemplate = "{+baseurl}/registrations/export/rev?RegistrationId={RegistrationId}";
/**
 * Mapper for query parameters from symbol name to serialization name represented as a constant.
 */
const RevRequestBuilderGetQueryParametersMapper: Record<string, string> = {
    "registrationId": "RegistrationId",
};
/**
 * Metadata for all the requests in the request builder.
 */
export const RevRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: RevRequestBuilderUriTemplate,
        responseBodyContentType: "application/problem+json",
        errorMappings: {
            400: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendPrimitive",
        responseBodyFactory:  "ArrayBuffer",
        queryParametersMapper: RevRequestBuilderGetQueryParametersMapper,
    },
};
/* tslint:enable */
/* eslint-enable */
